const SUBMITTED_NEW_POST = 'submitted new post for review';
const APPROVED = 'approved your post';
const REJECTED = 'rejected your post';
const RESUBMITTED_POST = 'resubmitted post for review';

const POST_REVIEW = Object.freeze({
	SUBMITTED_NEW_POST,
	APPROVED,
	REJECTED,
	RESUBMITTED_POST,
});

const POST_SCHEDULE_ERROR = Object.freeze({
	PUBLISH_PERMISSION_DENIED: 'publish permission denied',
	SCHEDULING_FAILED: 'scheduling failed',
});

export const NOTIFICATION_CONTENT_ACTIONS = Object.freeze({
	POST_REVIEW,
	POST_SCHEDULE_ERROR,
});
